module.exports = __webpack_public_path__ + "static/professional-9af451fef331c20dfd03b6f95b291456.jpg";